import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document\">\r\n    <path d=\"M317.44 475.428571h361.691429v73.142858H317.44zM317.622857 309.942857h178.834286v73.142857h-178.834286zM317.44 640.914286h361.691429v73.142857H317.44z\" p-id=\"13469\" />\r\n    <path d=\"M889.965714 273.737143L700.16 83.931429c-6.765714-6.948571-16.091429-10.788571-25.782857-10.788572H132.754286c-20.114286 0-36.571429 16.457143-36.571429 36.571429v804.571428c0 20.114286 16.457143 36.571429 36.571429 36.571429h731.428571c20.114286 0 36.571429-16.457143 36.571429-36.571429V299.52c0-9.691429-3.84-19.017143-10.788572-25.782857z m-192.914285-89.782857l95.085714 95.268571h-95.085714v-95.268571zM169.325714 877.714286V146.285714h454.4v132.937143c0 40.411429 32.731429 73.142857 73.142857 73.142857h130.742858V877.714286h-658.285715z\" p-id=\"13470\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/document.svg
// module id = mDNq
// module chunks = 197